import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import { skeletonVariants } from "./lib";
import type { SkeletonProps } from "./types";

export const Skeleton = ({
  variant = "rounded",
  radius,
  animate = true,
  className,
  testID,
}: SkeletonProps) => {
  return (
    <Box
      className={cn(
        skeletonVariants(radius ? { radius, animate } : { variant, animate }),
        className,
      )}
      {...platformProps({ testID, slot: "skeleton" })}
      aria-hidden
    />
  );
};

Skeleton.displayName = "Skeleton";
